import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const TemplatePickerDialog = ({
  showTemplatesPicker,
  setShowTemplatesPicker,
  orderTemplates,
  applyOrderTemplate,
  formatCurrency,
}) => (
  <Dialog open={showTemplatesPicker} onOpenChange={setShowTemplatesPicker}>
    <DialogContent className="sm:max-w-xl border border-zinc-200 rounded-none p-0 max-h-[80vh] overflow-hidden flex flex-col">
      <DialogHeader className="p-5 pb-0 flex-shrink-0">
        <DialogTitle className="text-xl font-heading font-bold uppercase tracking-wide">Order Templates</DialogTitle>
      </DialogHeader>
      <div className="p-5 pt-3 overflow-y-auto flex-1 space-y-2" data-testid="template-picker-list">
        {orderTemplates.length === 0 ? (
          <p className="text-center text-zinc-400 py-8">No templates available</p>
        ) : orderTemplates.map(tmpl => {
          const CATS = { electrical: 'bg-amber-100 text-amber-800', plumbing: 'bg-blue-100 text-blue-800', hvac: 'bg-green-100 text-green-800', mechanical: 'bg-red-100 text-red-800', general: 'bg-zinc-100 text-zinc-700' };
          return (
            <div key={tmpl.template_id} className="border border-zinc-200 p-3 hover:border-primary transition-colors cursor-pointer"
              onClick={() => applyOrderTemplate(tmpl)}
              data-testid={`order-template-${tmpl.template_id}`}>
              <div className="flex items-start justify-between gap-2">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-heading font-bold uppercase text-sm">{tmpl.name}</h4>
                    <span className={`px-2 py-0.5 text-[9px] font-bold uppercase ${CATS[tmpl.category] || CATS.general}`}>
                      {tmpl.category}
                    </span>
                    {tmpl.is_preset && <span className="px-2 py-0.5 text-[9px] font-bold uppercase bg-primary text-zinc-900">Preset</span>}
                  </div>
                  {tmpl.description && <p className="text-xs text-zinc-500 mb-1">{tmpl.description}</p>}
                  <p className="text-[10px] text-zinc-400">{tmpl.line_items?.length || 0} items</p>
                </div>
                <p className="font-mono font-bold text-sm whitespace-nowrap">{formatCurrency(tmpl.total || 0)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);
